import { parsePoliciesThroughput } from "views/Statistics/Throughput/PerPolicy/api.js";

// The same command as the throughput per policy, parsed for the subscribers.
export { policiesThroughputRetrieval } from "views/Statistics/Throughput/PerPolicy/api.js";

export const parseSystemDate = (input) => new Date(input);

export const parsePoliciesThroughputIgnoringSpeeds = (response) =>
  parsePoliciesThroughput(response, {
    ignore: ["upSpeed", "downSpeed"],
  });
